/**
 * Zod-free runtime constants. Browser code imports these from '@crowdset/contracts/constants'
 * so the schema library is not pulled into the client bundle; types come from the main entry.
 */
export { BRAND, PROTOCOL_VERSION } from './brand.js';
export { API, SOCKET_PATH } from './routes.js';

export const LIMITS = {
  chatBodyMax: 500,
  handleMin: 3,
  handleMax: 24,
  displayNameMax: 40,
  roomNameMax: 60,
  roomDescriptionMax: 280,
  genreTagMax: 24,
  genreTagsMax: 5,
  playlistNameMax: 60,
  playlistItemsMax: 500,
  playlistsPerUserMax: 50,
  reportDetailsMax: 1000,
  moderationReasonMax: 200,
  searchQueryMax: 100,
  pageSizeMax: 50,
  chatHistoryPage: 50,
} as const;

export const AVATAR_IDS = [
  'nova',
  'juno',
  'bramble',
  'koji',
  'marlo',
  'vesper',
  'tuck',
  'odette',
  'rafi',
  'sable',
] as const;

export const ROOM_THEMES = ['neon-club', 'rooftop', 'cozy-lounge'] as const;
